import { useGetInterests } from 'integration/hooks/useGetInterests';
import { PREFERENCES_CODE } from 'integration/hooks/useInterest';
import { useGetPreferredSizes } from 'integration/hooks/usePreferredSizes';
import { useUserInterests } from 'integration/hooks/useUserInterests';
import { useMemo } from 'react';

export const STYLES_CODE = 'estilos';
export const BRANDS_CODE = 'marcas';

export const useDpFanGroupsFetcher = () => {
	const preferredSizesQuery = useGetPreferredSizes();
	const interestsListQuery = useGetInterests();
	const userInterestsQuery = useUserInterests();

	const userStylesData = useMemo(
		() =>
			userInterestsQuery.userInterests?.find(
				(item) => item.name.toLocaleLowerCase().trim() === STYLES_CODE
			),
		[userInterestsQuery.userInterests]
	);

	const stylesListData = useMemo(
		() =>
			interestsListQuery.data?.find((item) => item.name.toLocaleLowerCase().trim() === STYLES_CODE),
		[interestsListQuery.data]
	);

	const userBrandsData = useMemo(
		() =>
			userInterestsQuery.userInterests?.find(
				(item) => item.name.toLocaleLowerCase().trim() === BRANDS_CODE
			),
		[userInterestsQuery.userInterests]
	);

	const brandsListData = useMemo(
		() =>
			interestsListQuery.data?.find((item) => item.name.toLocaleLowerCase().trim() === BRANDS_CODE),
		[interestsListQuery.data]
	);

	const userDayByDayData = useMemo(
		() =>
			userInterestsQuery.userInterests?.find(
				(item) => item.name.toLocaleLowerCase().trim() === PREFERENCES_CODE
			),
		[userInterestsQuery.userInterests]
	);

	const dayByDayListData = useMemo(
		() =>
			interestsListQuery.data?.find(
				(item) => item.name.toLocaleLowerCase().trim() === PREFERENCES_CODE
			),
		[interestsListQuery.data]
	);

	return {
		userStylesData,
		userBrandsData,
		userDayByDayData,
		stylesListData,
		brandsListData,
		dayByDayListData,
		interests: interestsListQuery.data,
		userInterests: userInterestsQuery.userInterests,
		preferredSizes: preferredSizesQuery.data || {},
		isLoadingPreferredSizes: preferredSizesQuery.isLoading,
		isLoadingInterests: interestsListQuery.isLoading,
		isLoadingUserInterests: userInterestsQuery.isLoadingUserInterests,
		isUserLoggedIn: userInterestsQuery.isUserLoggedIn,
		onUpdateUserInterests: userInterestsQuery.onUpdateUserInterests,
	};
};
